import React from 'react'

export default function HorizontalCard({title,desc,img}) {
  return (
    <div className="relative border border-gray-400 cursor-pointer group rounded-2xl hover:shadow-xl">
      <img
        crossOrigin="anonymous"
        src={img}
        alt={desc}
        className="object-cover xl:h-[434px] w-full rounded-2xl"
      />
      <div className="absolute w-full px-5 bottom-10 xl:px-14 ">
        {/* <h1 className="font-bold text-white">{title}</h1> */}
        {/* <p className="hidden text-sm font-semibold tracking-wide text-white group-hover:block descCardHrz">
          {desc}
        </p> */}
        <div dangerouslySetInnerHTML={{ __html: title }} />
      </div>
    </div>
  );
}
